<template>
    <div>
        <!--LISTADO-->
        <div v-if="menu == 0">
            <vs-table max-items="10" search pagination :data="arregloRecursos">
                <template slot="header">
                    <vs-chip color="primary">Cantidad: <b> {{ arregloRecursos.length }}</b></vs-chip>
                </template>
                <template slot="thead">
                    <vs-th>Recurso</vs-th>
                    <vs-th>Fechas</vs-th>
                    <vs-th>Observación</vs-th>
                    <vs-th v-if="userDocente">Tareas enviadas</vs-th>
                    <vs-th colspan="2" style="width:100px;">Acciones</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            <b>Nombre:</b>
                            <p>{{ tr.recurso }}</p>
                            <b>Categoria:</b>
                            <p class="mt-1">
                                <vs-chip color="success">{{ tr.tipo }}</vs-chip>
                            </p>
                        </vs-td>
                        <vs-td>
                            <b>Fecha inicio:</b>
                            <p>{{ tr.fecha_inicio }}</p>
                            <b>Fecha fin:</b>
                            <p>{{ tr.fecha_fin }}</p>
                        </vs-td>
                        <vs-td height="30%" width="30%">
                            <div class="overflow-y-auto h-24">
                                {{ tr.observacion }}
                            </div>
                        </vs-td>
                        <vs-td v-if="userDocente" width="20%">
                            {{ tr.tarea.length }}
                        </vs-td>
                        <vs-td align="center">
                            <button class="btnV" @click="recurso =tr;menu = 1;id =tr.id">
                                <feather-icon icon="AirplayIcon" svgClasses="h-4 w-4" class="ml-2" style="position: inherit;top:3px" />
                                <span class="ml-2">Revisar</span>
                            </button>
                            <!-- <vx-tooltip style="display: inline-block;" text="Ver Detalle" position="top" color="primary">
                                <vs-button style="display:inline-block" color="#D1CC34" icon-pack="feather" @click="recurso =tr;menu = 1;id =tr.id" icon="icon-eye" type="line">Ver Detalle</vs-button>
                            </vx-tooltip> -->
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
        <!--DETALLE-->
        <div v-if="menu == 1">
            <vs-button @click="menu = 0;" class="mt-3"><span class="text">← Regresar</span></vs-button>
            <DetalleRecursoVue :recurso="recurso" :codigoCurso="codigoCurso"/>
        </div>
    </div>
    </template>
    <script>
    import DetalleRecursoVue from './DetalleRecurso.vue'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import axios from 'axios'
    export default {
        data() {
            return {
                id: 0,
                menu: 0,
                usuario: [],
                recurso: {},
                userDocente:false,
            }
        },
        components: {
            flatPickr,
            DetalleRecursoVue,
        },
        props:{
            codigoCurso:{
                type:String,
                default:'',
            },
            arregloRecursos:{
                type:Array,
                default:[]
            },
            filtro:{
                type:Number,
                default:0
            },
        },
        watch:{
            filtro(results){
                let me = this;
                me.menu = 0
            }
        },
        created() {
            let me = this;
            me.usuario          = JSON.parse(localStorage.getItem("usuario"))[0]
        },
        mounted() {
            let me = this;
            if(me.usuario.id_group == 6) me.userDocente = true
        },
        methods: {
           
        }
    }
    </script>
    
    <style scoped>
    .button-38 {
        background-color: #FFFFFF;
        border: 0;
        border-radius: 25px;
        box-sizing: border-box;
        color: #111827;
        font-family: "Inter var", ui-sans-serif, system-ui, -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        font-size: .875rem;
        font-weight: 600;
        line-height: 1.25rem;
        padding: .75rem 1rem;
        text-align: center;
        text-decoration: none #D1D5DB solid;
        text-decoration-thickness: auto;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
        cursor: pointer;
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
    }
    
    .button-38:hover {
        background-color: rgb(249, 250, 251);
    }
    
    .button-38:focus {
        outline: 2px solid transparent;
        outline-offset: 2px;
    }
    
    .button-38:focus-visible {
        box-shadow: none;
    }
    
    /**Btn regresar */
    .button-48 {
        appearance: none;
        background-color: #FFFFFF;
        border-width: 0;
        box-sizing: border-box;
        color: #000000;
        cursor: pointer;
        display: inline-block;
        font-family: Clarkson, Helvetica, sans-serif;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 1em;
        margin: 0;
        opacity: 1;
        outline: 0;
        padding: 1em 2.2em;
        position: relative;
        text-align: center;
        text-decoration: none;
        text-rendering: geometricprecision;
        text-transform: uppercase;
        transition: opacity 300ms cubic-bezier(.694, 0, 0.335, 1), background-color 100ms cubic-bezier(.694, 0, 0.335, 1), color 100ms cubic-bezier(.694, 0, 0.335, 1);
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
        vertical-align: baseline;
        white-space: nowrap;
    }
    
    .button-48:before {
        animation: opacityFallbackOut .5s step-end forwards;
        backface-visibility: hidden;
        background-color: #EBEBEB;
        clip-path: polygon(-1% 0, 0 0, -25% 100%, -1% 100%);
        content: "";
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        transform: translateZ(0);
        transition: clip-path .5s cubic-bezier(.165, 0.84, 0.44, 1), -webkit-clip-path .5s cubic-bezier(.165, 0.84, 0.44, 1);
        width: 100%;
    }
    
    .button-48:hover:before {
        animation: opacityFallbackIn 0s step-start forwards;
        clip-path: polygon(0 0, 101% 0, 101% 101%, 0 101%);
    }
    
    .button-48:after {
        background-color: #FFFFFF;
    }
    
    .button-48 span {
        z-index: 1;
        position: relative;
    }
    .link{
        font-weight: 700;
        text-decoration: underline;
        cursor: pointer;
        transition: 1s ease;
    }
    .link:hover{
        color: cornflowerblue;
    }
    /**ESTILOS BOTONES */
    .btnV{
        color:#3E4448;
        background-color:#EBF3F8;
        border: none;
        padding: 5px 10px;
        border-radius: 5px;
        font-weight: 100;
        font-size: 11px;
        transition: 0.5s ease;
        cursor: pointer;
    }
    .btnV:hover{
        color: #3EA0EA;
    }
    </style>
    